
<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"DRIVER OBJECTS"'></app-infrastructure-header>

<!-- Main Screen which shows the Driver Objects and Driver Object Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#driver-object-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> DRIVER OBJECTS</a></li>
			<li class=""><a data-toggle="tab" href="#driver-objects-tab" aria-expanded="false"><i class="fa fa-star-o"></i> DRIVER OBJECT TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Driver Objects Tab -->
			<div id="driver-objects-tab" class="tab-pane fade">

				<!-- Add Driver Object Type and Options buttons -->
				<button (click)="addDriverObjectClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em>
					ADD DRIVER OBJECT TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedDriverObjectClicked()"
							[class.disabled]="!isSingleDriverObjectSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedDriverObjectClicked()"
							[class.disabled]="!isSingleDriverObjectSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedDriverObjectsClicked()"
							[class.disabled]="!isAnyDriverObjectsSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedDriverObjectsToGroupClicked()"
							[class.disabled]="!isAnyDriverObjectsSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedDriverObjectsFromGroupClicked()"
							[class.disabled]="!isAnyDriverObjectsSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageDriverObjectGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
					</ul>
				</div>

				<!-- Filter (dropdown + type-aware value input) -->
				<app-filter-bar
					[options]="filterOptionForDriverObjects"
					[(selected)]="selectedFilterOptionForDriverObject"
					(filterChanged)="onDriverObjectFilterChanged($event)">
				</app-filter-bar>

				<!-- Results per page (if selected) or default -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>

				<!-- Driver Objects -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllDriverObjectsSelected()"
										(change)="setAllDriverObjectsSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let driverObject of mDriverObjects | paginate: {id: 'driverobject_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageForDriverObject, totalItems: totalNumberOfDriverObjects }">
						<tr class="" role="row">
							<td><input type="checkbox" [(ngModel)]="driverObject.mSelected" /></td>
							<td (click)="editDriverObject(driverObject.mDriverObject)"  (contextmenu)="fetchFunctionList($event, driverObject.mDriverObject)">
								{{driverObject.mDriverObject.name}}</td>
							<td>
								<ng-container
									*ngIf="driverObject.mDriverObject.groups != null && driverObject.mDriverObject.groups.length > 0">
									<ng-container *ngFor="let group of driverObject.mDriverObject.groups">
										<button class="groupButton" (click)="showGroup(group)">{{group.name}}</button>
									</ng-container>
								</ng-container>
							</td>
						</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination Controls for Driver Object -->
				<pagination-controls class="pagination" id="driverobject_pagination"
					(pageChange)="pageChangedDriverObject($event)" [directionLinks]="true" nextLabel="Next"
					previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>

			<!-- Driver Object Instances Tab -->
			<div id="driver-object-instances-tab" class="tab-pane fade active in">

				<!-- Add Driver Object and Options buttons -->
				<button (click)="addDriverObjectInstanceClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD DRIVER OBJECT</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedDriverObjectInstanceClicked()"
							[class.disabled]="!isSingleDriverObjectInstanceSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedDriverObjectInstanceClicked()"
							[class.disabled]="!isSingleDriverObjectInstanceSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedDriverObjectInstancesClicked()"
							[class.disabled]="!isAnyDriverObjectInstancesSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedDriverObjectInstancesToGroupClicked()"
							[class.disabled]="!isAnyDriverObjectInstancesSelected()"><a><em class="fa fa-plus"></em> ADD
								TO GROUP</a></li>
						<li (click)="removeSelectedDriverObjectInstancesFromGroupClicked()"
							[class.disabled]="!isAnyDriverObjectInstancesSelected()"><a><em class="fa fa-remove"></em>
								REMOVE FROM GROUP</a></li>
						<li (click)="manageDriverObjectInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
					</ul>
				</div>

				<!-- Filter (dropdown + type-aware value input) -->
				<app-filter-bar
					[options]="filterOptionForDriverObjectInstances"
					[multiple]="true" [(active)]="activeFilterOptionsForDriverObjectInstance"
					(filterChanged)="onDriverObjectInstanceFilterChanged($event)">
				</app-filter-bar>

				<!-- Results per page (if selected) or default -->
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>

				<!-- Driver Object Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllDriverObjectInstancesSelected()"
										(change)="setAllDriverObjectInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Name</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Driver Object Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container *ngFor="let driverObjectInstance of mDriverObjectInstances | paginate: {id: 'driverobjectinstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageForDriverObjectInstance, totalItems: totalNumberOfDriverObjectInstances }">
							<tr class="" role="row">
								<td><input type="checkbox" [(ngModel)]="driverObjectInstance.mSelected" /></td>
								<td (click)="editDriverObjectInstance(driverObjectInstance.mDriverObjectInstance)" (contextmenu)="fetchFunctionList($event, driverObjectInstance.mDriverObjectInstance)">
									{{driverObjectInstance.mDriverObjectInstance.name}}</td>
								<td (click)="editDriverObjectInstance(driverObjectInstance.mDriverObjectInstance)">
									{{driverObjectInstance.mDriverObjectInstance.driverObject.name}}</td>
								<td>
									<ng-container
										*ngIf="driverObjectInstance.mDriverObjectInstance.groups != null && driverObjectInstance.mDriverObjectInstance.groups.length > 0">
										<ng-container
											*ngFor="let group of driverObjectInstance.mDriverObjectInstance.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<!-- Pagination conyrols for "Driver Object Instance" -->
				<pagination-controls class="pagination" id="driverobjectinstance_pagination"
					(pageChange)="pageChangedDriverObjectInstance($event)" [directionLinks]="true" nextLabel="Next"
					previousLabel="Prev" [autoHide]="true">
				</pagination-controls>

			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance" 
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()" >
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance" [instanceType]="mInstanceType"
	[function]="selectedFunction"></app-general-function-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>